import React from "react";
import { Typography, Box, Button } from "@material-ui/core";
import styles from "../styles";

function TitleIXNotificationText({ displayAccommodationTypes }) {
  const classes = styles();

  return (
    <>
      <Box style={{ marginBottom: "24px" }}>
        <Typography>
          A student in your course is eligible for accommodations.
        </Typography>
      </Box>

      <Box style={{ marginBottom: "24px" }}>
        <Typography component="h3" className={classes.subHeadingText}>
          Please implement the following Title IX accommodation(s) approved under University policy:
        </Typography>
      </Box>

      <Box style={{ marginBottom: "24px" }}>
        <Typography className={classes.accomText}>
          {displayAccommodationTypes.length > 0 &&
            displayAccommodationTypes.map(
              (accommodation, index) => (
                <React.Fragment key={index}>
                  <Typography display="inline">
                    {accommodation && accommodation !== "null" && `${accommodation}${index < displayAccommodationTypes.length - 1 ? `; ` : ''}`}
                  </Typography>
                </React.Fragment>
              )
            )}
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          {`You may access information about these accommodations in the `}
          <Button
            href={process.env.REACT_APP_ACCOMMODATION_DICTIONARY_URL}
            target="_blank"
            className={classes.popUpLinkText}
            disableRipple
          >
            {`Accommodations Dictionary`}
          </Button>
          {` available on the Faculty Resources Center. Students can also access the same information in the `}
          <Button
            href={process.env.REACT_APP_STUDENT_ACCOMMODATION_DICTIONARY_URL}
            target="_blank"
            className={classes.popUpLinkText}
            disableRipple
          >
            {`Student Accommodations Dictionary`}
          </Button>
          {` in the My Phoenix Help Topics.`}
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          {`The `}
          <Button
            href={`${process.env.REACT_APP_ACCOMMODATION_DICTIONARY_URL}#Faculty-Responsibilities-Title-IX`}
            target="_blank"
            className={classes.popUpLinkText}
            disableRipple
          >
            {`Faculty Responsibilities – Title IX`}
          </Button>
          {` section of the Accommodations Dictionary outlines what you are required to do to implement the accommodations effectively.`}
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          {`Please also review the `}
          <Button
            href={`${process.env.REACT_APP_ACCOMMODATION_DICTIONARY_URL}#SAO-Custom-Header`}
            target="_blank"
            className={classes.popUpLinkText}
            disableRipple
          >
            {`Setting Up Accommodations`}
          </Button>
          {` section which will show you how to note on the roster this student has accommodations.`}
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          Any information pertaining to the student's accommodations must remain private. The reason the student qualifies for accommodations will not be disclosed, as this information is not necessary to implement the accommodations.
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          If you have any questions, please do not hesitate to contact us for more information.
        </Typography>
      </Box>

      <Box className={classes.textBlock}>
        <Typography display="inline">
          Thank you for all you do to support our students!
        </Typography>
      </Box>

      <Box className={classes.thankyouContainer}>
        <Typography> Regards, </Typography>
        <Typography className={classes.justBold} style={{ marginTop: "16px", marginBottom: "16px" }}>
          Title IX Office
        </Typography>
        <Typography className={classes.justBold}>
          University of Phoenix
        </Typography>
        <Typography>
          4035 S Riverpoint Pkwy Phoenix, AZ 85040
        </Typography>
        <Typography>
          Phone 602.557.6176
        </Typography>
        <Typography>
          <a href="mailto:Title.IXUOP@phoenix.edu" style={{ color: "#30718D", textDecoration: "underline" }}>
            Title.IXUOP@phoenix.edu
          </a>
        </Typography>
      </Box>
    </>
  );
}

export default TitleIXNotificationText;
